var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.46+435.748L418.019+415.67L419.923+384.688L437.578+368.764",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.847+458.25L455.405+438.172L457.309+407.189L474.964+391.265",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.979+434.537L437.751+456.173L419.576+414.978L456.271+437.479L421.654+385.38L458.694+405.977L437.578+369.456L474.445+392.823",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.46+435.748L418.019+415.67L419.923+384.688L437.578+368.764",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 3.3,
    d: "M7.63303+32.3425L32.8318+48.2446L57.3456+32.0489L32.0979+17.3211L7.63303+32.3425Z",
    fill: "none",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 3.3,
    d: "M21.1376+24.1713",
    fill: "none",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.109287,
    d: "M31.8532+31.9511L20.7951+25.1009L31.7554+18.789L43.4006+24.8563L31.8532+31.9511Z",
    fill: "currentColor",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.109287,
    d: "M32.8807+46.7768L19.7187+39.4373L31.8532+31.8043L44.526+39.9266L32.8807+46.7768Z",
    fill: "currentColor",
    strokeLinecap: "round",
    opacity: 1,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRaster);
export default __webpack_public_path__ + "static/media/ic_raster.95a1938224ef19af128a51fe441e50c6.svg";
export { ForwardRef as ReactComponent };